import { apiData, type Schema } from "./api";

export async function getPublicConfig(): Promise<Schema<"PublicConfigResponse">> {
  return apiData<Schema<"PublicConfigResponseEnvelope">>("/config");
}
